<div class="easy-spinner" style="display: none;" [id]="name + 'easy-spinner'">
  <div class="background-easy-spinner"></div>
  <div class="easy-spinner-content">
      <img [src]="image">
      <p class="animate-text">{{text}}</p>
  </div>
</div>